// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// "main" is not very TS-friendly, but has to be a TS file for Vue to run.
// Polyfills
import "@/polyfills";
import "vue-toast-notification/dist/theme-default.css";
import "wicg-inert";
// We use the raw Bootstrap SCSS as the dist files contain deprecated properties
import "bootstrap/scss/bootstrap.scss";
import "@/vee-validate";
// Design System Kit
import "@/abc-dsk"; // TODO Ideally this should come from the abc-dsk package (global-style.ts)
import "@ordbogen-npm/abc-dsk/abc-dsk.css";

// Dependencies
import VueAccessibleSelect from "@jonasclement/vue-accessible-select";
import * as Sentry from "@sentry/vue";
import vClickOutside from "click-outside-vue3";
import { createPinia } from "pinia";
import PiniaPluginPersistedState from "pinia-plugin-persistedstate";
import { createApp } from "vue";
import VueMatomo from "vue-matomo";
import VueToast from "vue-toast-notification";

// Project Dependencies
import App from "@/App.vue";
import config from "@/common/config";
import ConfigService from "@/common/config.service";
import CookieService from "@/common/cookie.service";
import { testOnly, vMatomoEvent } from "@/directives";
import { i18n, init as i18nInit } from "@/i18n";
import router from "@/router";

import ApiService from "./common/api/api.service";
import { responseErrorInterceptor } from "./common/api/error-interceptor";
import { useLoader } from "./common/composables/use-loader.composable";

// Do trivial tasks that needs to be done before showing the initial page
const { showLoadingWhile } = useLoader(router);
showLoadingWhile([i18nInit()]);

const app = createApp(App);

if (config.sentry.enabled) {
  Sentry.init({
    app,
    dsn: config.sentry.dsn,
    environment: config.sentry.environment,
    attachProps: true,
    trackComponents: true,
    logErrors: true,
    tracesSampleRate: 0.05
  });
}

// Setup response interceptor in main.ts to avoid circular dependency with router.
ApiService.api.interceptors.response.use(undefined, responseErrorInterceptor);

const pinia = createPinia();
pinia.use(PiniaPluginPersistedState);

app.use(pinia);
app.use(router);
app.use(i18n);
app.use(ConfigService);
app.use(VueToast);
app.use(vClickOutside);
app.use(VueAccessibleSelect);

app.directive("matomo-event", vMatomoEvent);
app.directive("test-only", testOnly);

app.use(VueMatomo, {
  host: config.matomo.host,
  siteId: config.matomo.siteId,
  disableCookies: true,
  router: router,
  enableHeartBeatTimer: true,
  userId: CookieService.getWithoutPrefix("pcident")
});

// Provide the router instance, for use in Pinia stores.
// Doing `import route from '@/router'` inside pinia store, somehow breaks the build pipeline.
// Doing `useRouter()` inside pinia route, sometimes resolves `router` as undefined, even when we should be in component-context O.o
app.provide("$router", router);

router.isReady().then(() => app.mount("#app"));
